import { render, staticRenderFns } from "./addMedicalCase.vue?vue&type=template&id=6ac2a1b2&scoped=true&"
import script from "./addMedicalCase.vue?vue&type=script&lang=js&"
export * from "./addMedicalCase.vue?vue&type=script&lang=js&"
import style0 from "./addMedicalCase.vue?vue&type=style&index=0&id=6ac2a1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2a1b2",
  null
  
)

export default component.exports